import './meal_exploration_slidebars.css'

import React, { useState, useRef, useEffect } from 'react';
import { get, post } from '../../Services/api';
import { useAuth } from '../../Components/AuthContext/AuthContext'
import MealCard from '../MealCard/MealCard';
import { MdExpandMore, MdExpandLess } from "react-icons/md";

function MealExplorationSlideBars({ customMealFunction }) {

    const { currentUser } = useAuth();
    const [tredningMeals, setTredningMeals] = useState([]);
    const [favoriteMeals, setFavoriteMeals] = useState([]);
    const [pickedForYouMeals, setPickedForYouMeals] = useState([]);

    const [pfuExpanded, setPFUExpanded] = useState(false);
    const [trendingExpanded, setTrendingExpanded] = useState(false);
    const [favExpanded, setFavExpanded] = useState(false);

    // Function to fetch search results from the server
    const fetchResults = async () => {
        try {

            const result = await get('api/meal/get-trending-meals', {
                user_id: currentUser.uid,
                count: 5
            })

            const favorite = await get('api/meal/get-favorite-meals', {
                user_id: currentUser.uid,
                count: 5
            })

            const pfu = await get('api/meal/get-picked-for-you-meals', {
                user_id: currentUser.uid,
                count: 5

            })

            setPickedForYouMeals(pfu);
            setFavoriteMeals(favorite);
            setTredningMeals(result);
        } catch (error) {
            console.error('Error fetching search results:', error);
        }
    };

    useEffect(() => {
        fetchResults();
    }, []);




    return (

        <div className='add_meal_defualt_options'>
            {/* Picked for you */}
            <div className='meal_exploration_slidebars_trending'>
                <div className='flex gap_6 align_center'>
                    <p className='font_family_ovo gray_scale_6 font_size_24' style={{ cursor: 'pointer' }} onClick={() => {
                        setPFUExpanded(!pfuExpanded)
                    }}>Picked For You</p>
                    <span style={{ cursor: 'pointer' }} onClick={() => {
                        setPFUExpanded(!pfuExpanded)
                    }}>
                        {

                            pfuExpanded ? <MdExpandLess color='#21201F' size={25} /> : <MdExpandMore color='#21201F' size={25} />
                        }

                    </span>
                </div>
                {
                    pfuExpanded && <div className='meal_exploration_slidebars_items'>
                        {pickedForYouMeals.map((meal) => {
                            return (
                                <MealCard wantSmall={true} item={meal} customMealCardFunction={customMealFunction} />
                            )
                        })}
                    </div>
                }

            </div>

            {/* Trending this week */}
            <div className='font_family_ovo meal_exploration_slidebars_trending'>
                <div className='flex gap_6 align_center'>
                    <p className='font_family_ovo gray_scale_6 font_size_24' style={{ cursor: 'pointer' }} onClick={() => {
                        setTrendingExpanded(!trendingExpanded)
                    }}>Trending Meals</p>
                    <span style={{ cursor: 'pointer' }} onClick={() => {
                        setTrendingExpanded(!trendingExpanded)
                    }}>
                        {

                            trendingExpanded ? <MdExpandLess color='#21201F' size={25} /> : <MdExpandMore color='#21201F' size={25} />
                        }

                    </span>
                </div>
                {
                    trendingExpanded && <div className='meal_exploration_slidebars_items'>

                        {tredningMeals.map((meal) => {
                            return (
                                <MealCard wantSmall={true} item={meal} customMealCardFunction={customMealFunction} />
                            )
                        })}
                    </div>
                }
            </div>

            {/* Everyone's favorite */}
            <div className='font_family_ovo meal_exploration_slidebars_trending'>
                <div className='flex gap_6 align_center'>
                    <p className='font_family_ovo gray_scale_6 font_size_24' style={{ cursor: 'pointer' }} onClick={() => {
                        setFavExpanded(!favExpanded)
                    }}>Everyone's Favorite</p>
                    <span style={{ cursor: 'pointer' }} onClick={() => {
                        setFavExpanded(!favExpanded)
                    }}>
                        {

                            favExpanded ? <MdExpandLess color='#21201F' size={25} /> : <MdExpandMore color='#21201F' size={25} />
                        }

                    </span>
                </div>
                {
                    favExpanded && <div className='meal_exploration_slidebars_items'>

                        {favoriteMeals.map((meal) => {
                            return (
                                <MealCard wantSmall={true} item={meal} customMealCardFunction={customMealFunction} />
                            )
                        })}
                    </div>
                }
            </div>
        </div >



    );
}

export default MealExplorationSlideBars;
